<template>
  <b-row class="d-block d-lg-none">
    <b-col class="p-0">
      <router-link to="/landing">
        <div class="nav-footer">
          <i id="home-icon" class="icon-home vtd-icon-7"/>
        </div>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
export default {
  computed: {
  },
};
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>